import { ButtonAPI, FieldAPI, FormAPI, ModalService } from '@philips-internal/oswald-ui-components';
import Controller, { OnChange, OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import { CONFIRMATION_FIELD_VALID, confirmationFieldValidator, NEW_PWD_VALIDATOR, newPwdValidator, optionsValidator } from '../../utils/user-util';
import { ChangeEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Value } from '@philips-internal/oswald-ui-core';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { HttpResponse } from '@philips-internal/oswald-ui-core/lib/services/http-service';
import { ToastResponse } from '../../interfaces/ToastResponse';
import { SubmittableFragmentContext } from '@philips-internal/oswald-ui-core/lib/component/context';
import { Inject } from '@odinjs/odin';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { forEachMessageShowToast } from '../../services/toast-notication-utils';
import { FragmentNames } from '../../codegen';
import Types from '@philips-internal/oswald-ui-constants/lib/type';

@Controller({ fragment: FragmentNames.CHANGE_EXPIRED_PASSWORD, component: 'renew-layout' })
class ChangeExpiredPasswordController extends BaseController {

  @Inject('old-password-field')
  fieldActualPassword: FieldAPI;

  @Inject('new-password-field')
  fieldNewPassword: FieldAPI;

  @Inject('confirm-password-field')
  fieldNewConfirmPassword: FieldAPI;

  @Inject('renew-form')
  formPassword: FormAPI;

  @Inject('change-password-submit-button')
  confirmBtn: ButtonAPI;

  @Inject('SubmittableFragmentContext')
  submittableFragmentContext!: SubmittableFragmentContext;

  @OnMount({ target: ['renew-layout'] })
  onMountModalAltPassword(): void {
    this.fieldNewConfirmPassword.addLocalValidator(CONFIRMATION_FIELD_VALID, (value) => {
      const confirmationValue = this.formPassword.getRecord()['newPassword'] || '';
      return confirmationFieldValidator(value, confirmationValue, 'pwd');
    }, optionsValidator());
    this.fieldNewPassword.addLocalValidator(NEW_PWD_VALIDATOR, (value) => {
      const currentPassword = this.formPassword.getRecord()['password'] || '';
      return newPwdValidator(value, currentPassword);
    });
    this.confirmBtn.setEnabled(false);
  }

  @OnChange({ target: ['renew-form'] })
  async onChangeRenewPassword({ value }: ChangeEvent<Record<string, Value>>): Promise<void> {
    this.confirmBtn.setEnabled(await this.isDataValid(value));
  }

  async isDataValid(value: Record<string, Value>): Promise<boolean> {
    return await this.fieldNewPassword.validate() &&
      await this.fieldNewConfirmPassword.validate() &&
      Boolean(value['newPassword']) &&
      Boolean(value['confirmPassword']) &&
      (value['newPassword'] === value['confirmPassword']);
  }

  @OnClick({ target: ['change-password-submit-button'] })
  onClickAltPassword(): void {
    this.confirmBtn.setEnabled(false);
    this.formPassword.setEditing(false);
    this.renewPassword();
  }

  renewPassword(): void {
    const body = this.formPassword.getRecord();
    body.login = this.context.get('username');
    HttpService.post(APPLICATION_ENDPOINTS.POST_RENEW_PASSWORD, {}, { body }).then(resp => {
      this.handleSuccess(resp);
    }).catch(resp => {
      this.handleFailure(resp);
    });
  }

  handleSuccess(response: HttpResponse<unknown>): void {
    const toastResponse = response.body as ToastResponse;
    toastResponse.type = Types.SAFETY;
    if (toastResponse?.messages) {
      forEachMessageShowToast(toastResponse);
      ModalService.close(FragmentNames.CHANGE_EXPIRED_PASSWORD);
    }
  }

  async handleFailure(response: HttpResponse<unknown>): Promise<void> {
    this.formPassword.setEditing(true);
    this.confirmBtn.setEnabled(await this.isDataValid(this.formPassword.getRecord()));

    const toastResponse = response.body as ToastResponse;
    forEachMessageShowToast(toastResponse);
  }
}

export default ChangeExpiredPasswordController;
